module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--AT-54a1599b31aac2c7ac0fc36d2aa663b7.jpg";